// extracted by mini-css-extract-plugin
export default {"storyTimeline":"c-a_gT","storyTimeline__item":"c-a_gU","storyTimeline__item_complete":"c-a_gV","storyTimeline__item_withProgress":"c-a_gW"};